module.exports = __webpack_public_path__ + "static/media/microscope.2cf66412.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/microscope.png
// module id = 128
// module chunks = 0